import { PropsWithChildren } from 'react';
import SvgAlert from '@icons/Alert.tsx';

interface ComponentProps {
  title: string;
  highlighted: boolean;
}

// Same layout as ListInfoItem, but the title is prefixed with a warning icon when the field has
// content. Label stringifies its title, so the icon cannot be passed through it.
const HighlightedListInfoItem: React.FC<PropsWithChildren<ComponentProps>> = ({ title, highlighted, children }) => (
  <div className="flex flex-col gap-0.5">
    <div className="label-panel p-mb-2">
      <label className="flex items-center gap-2">
        {highlighted && <SvgAlert fill={'var(--ringil3-complementary-warning)'} width={'16px'} height={'16px'} />}
        <strong>{title}</strong>
      </label>
    </div>
    <div>{children}</div>
  </div>
);

export default HighlightedListInfoItem;
